export default __webpack_public_path__ + "static/media/cart.a5912f79.svg";